<script lang="ts">
    import { silentStore } from "../../Stores/MediaStore";

    import {
        inExternalServiceStore,
        myCameraStore,
        myMicrophoneStore,
        proximityMeetingStore,
    } from "../../Stores/MyMediaStore";
    import { mediaSettingsOpenStore, rightActionBarMenuItems } from "../../Stores/MenuStore";
    import { IconChevronUp } from "../Icons";
    import { screenSharingAvailableStore } from "../../Stores/ScreenSharingStore";
    import { isInRemoteConversation } from "../../Stores/StreamableCollectionStore";
    import LL from "../../../i18n/i18n-svelte";
    import MediaSettingsList from "./MediaSettingsList/MediaSettingsList.svelte";
    import CameraMenuItem from "./MenuIcons/CameraMenuItem.svelte";
    import MicrophoneMenuItem from "./MenuIcons/MicrophoneMenuItem.svelte";
    import ScreenSharingMenuItem from "./MenuIcons/ScreenSharingMenuItem.svelte";
    import ResponsiveActionBar from "./ResponsiveActionBar.svelte";
    import ContextualMenuItems from "./MenuIcons/ContextualMenuItems.svelte";
    import EmojiMenuItem from "./MenuIcons/EmojiMenuItem.svelte";
    import SilentBlock from "./SilentBlock.svelte";
    import PictureInPictureMenuItem from "./MenuIcons/PictureInPictureMenuItem.svelte";
    import ProfileMenu from "./MenuIcons/ProfileMenu.svelte";
    import { createFloatingUiActions } from "../../Utils/svelte-floatingui";

    const [mediaSettingsRef, mediaSettingsContent] = createFloatingUiActions({ placement: "top" }, 8);

    $effect(() => {
        for (const item of $rightActionBarMenuItems) {
            item.fallsInBurgerMenuStore.set(true);
        }
    });
</script>

<div class="flex flex-col mobile:flex-col-reverse">
    <ResponsiveActionBar>
        {#snippet left()}
            <ProfileMenu compact />
        {/snippet}

        {#snippet center()}
            <div class="main-action pointer-events-auto flex items-center justify-center">
                <div class="relative z-[1] flex items-center justify-center gap-1">
                    <div class="@sm/actions:hidden">
                        <EmojiMenuItem />
                    </div>
                    <div class="hidden items-center @sm/actions:flex">
                        <ContextualMenuItems />
                    </div>

                    <div>
                        <!-- ACTION WRAPPER : CAM & MIC -->
                        <div class="group/hardware relative flex items-center">
                            {#if !$inExternalServiceStore && $proximityMeetingStore && $myMicrophoneStore}
                                <MicrophoneMenuItem />
                            {/if}

                            {#if !$inExternalServiceStore && ($myMicrophoneStore || $myCameraStore)}
                                <button
                                    type="button"
                                    data-testid="media-settings-toggle-button"
                                    aria-label={$LL.actionbar.editCamMic()}
                                    aria-expanded={$mediaSettingsOpenStore}
                                    use:mediaSettingsRef
                                    class="nutrivera-action-button relative m-0 flex h-10 min-w-10 flex-none items-center justify-center rounded-[10px] bg-[var(--nutrivera-shell-raised)] p-1 text-[var(--nutrivera-shell-text)] outline-none transition-colors duration-200 hover:bg-[var(--nutrivera-shell-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--nutrivera-shell-accent)]"
                                    onclick={(event) => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        mediaSettingsOpenStore.set(!$mediaSettingsOpenStore);
                                    }}
                                >
                                    <IconChevronUp
                                        stroke="2"
                                        class="aspect-square select-none transition-all {$mediaSettingsOpenStore
                                            ? 'rotate-180'
                                            : ''}"
                                    />
                                </button>
                            {/if}
                            {#if $mediaSettingsOpenStore}
                                <MediaSettingsList
                                    floatingAction={mediaSettingsContent}
                                    onclose={() => mediaSettingsOpenStore.set(false)}
                                />
                            {/if}
                            <!-- NAV : CAMERA START -->
                            {#if !$inExternalServiceStore && $myCameraStore}
                                <CameraMenuItem />
                            {/if}
                            <!-- NAV : CAMERA END -->

                            <!-- NAV : SCREENSHARING START -->
                            {#if $screenSharingAvailableStore}
                                <ScreenSharingMenuItem />
                            {/if}
                            <!-- NAV : SCREENSHARING END -->
                        </div>
                    </div>
                </div>
            </div>
        {/snippet}

        {#snippet right()}
            {#if $isInRemoteConversation}
                <PictureInPictureMenuItem />
            {/if}
        {/snippet}
    </ResponsiveActionBar>
    <!-- NAV : SILENT BLOCK -->
    {#if $silentStore}
        <SilentBlock />
    {/if}
</div>
